import React from "react";

export const ConversationSkeleton: React.FC = () => {
  return (
    <div
      style={{
        width: "100%",
        maxWidth: "900px",
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        padding: "20px 0",
      }}
    >
      {/* Skeleton for user message */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          animation: "fadeIn 0.3s ease-in",
        }}
      >
        <div
          style={{
            width: "60%",
            height: "60px",
            backgroundColor: "#e9ecef",
            borderRadius: "18px",
            borderBottomRightRadius: "5px",
            animation: "pulse 1.5s ease-in-out infinite",
          }}
        />
      </div>

      {/* Skeleton for assistant message */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          animation: "fadeIn 0.3s ease-in 0.2s both",
        }}
      >
        <div
          style={{
            width: "80%",
            display: "flex",
            flexDirection: "column",
            gap: "12px",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "120px",
              backgroundColor: "#f8f9fa",
              borderRadius: "18px",
              borderBottomLeftRadius: "5px",
              animation: "pulse 1.5s ease-in-out infinite",
            }}
          />
          <div
            style={{
              width: "70%",
              height: "80px",
              backgroundColor: "#f8f9fa",
              borderRadius: "18px",
              animation: "pulse 1.5s ease-in-out infinite",
              animationDelay: "0.2s",
            }}
          />
        </div>
      </div>

      <style>
        {`
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
        `}
      </style>
    </div>
  );
};
